import PropTypes from 'prop-types';
import { withBlockExtensions } from '@plone/volto/helpers/Extensions';
import SidebarPortal from '@plone/volto/components/manage/Sidebar/SidebarPortal';
import Data from './Data';
import Body from './Body';

const Edit = (props) => {
  const { data, block, selected } = props;

  return (
    <>
      <Body isEditMode {...props} />
      <SidebarPortal selected={selected}>
        <Data key={block} {...props} data={data} block={block} />
      </SidebarPortal>
    </>
  );
};

Edit.propTypes = {
  block: PropTypes.string,
  onChangeBlock: PropTypes.func,
  selected: PropTypes.bool,
};

export default withBlockExtensions(Edit);
